import { GlobalStorage } from "@otto-ec/global-client-storage";

/*🤫*/
window.o_global = window.o_global || {};
window.o_global.Storage = window.o_global.Storage || GlobalStorage;
